import { __ } from '@wordpress/i18n';
import { Plus, Settings, ShoppingBag } from 'lucide-react';
import { DokanButton } from '@dokan/components';
import HeaderCard from './HeaderCard';

type Props = {
    active: 'quotes' | 'rules';
};

const HeaderSection = ( props: Props ) => {
    const { active } = props;

    const redirectTo = ( hashPath: string ) => {
        if ( hashPath.startsWith( '#' ) ) {
            window.location.hash = hashPath;
        } else {
            window.location.hash = `#${ hashPath.replace( /^#/, '' ) }`;
        }
    };

    return (
        <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-5">
                <HeaderCard
                    redirectTo={ redirectTo }
                    active={ active !== 'rules' }
                    icon={ <ShoppingBag size={ 24 } /> }
                    title={ __( 'Quote List', 'dokan' ) }
                    href="/request-for-quote"
                />
                <HeaderCard
                    redirectTo={ redirectTo }
                    active={ active !== 'quotes' }
                    icon={ <Settings size={ 24 } /> }
                    title={ __( 'Quote Rules List', 'dokan' ) }
                    href="/request-for-quote/quote-rules"
                />
            </div>
            <DokanButton
                link={ true }
                type="primary"
                href={
                    active !== 'rules'
                        ? '#/request-for-quote/add-new-quote'
                        : '#/request-for-quote/add-new-rule'
                }
                className="flex items-center gap-2.5 rounded-md px-6 py-3 m-0"
            >
                <Plus size={ 16 } strokeWidth={ 2.5 } />
                { active !== 'rules'
                    ? __( 'New Quote', 'dokan' )
                    : __( 'New Quote Rules', 'dokan' ) }
            </DokanButton>
        </div>
    );
};

export default HeaderSection;
